/** Dispatch actions */
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_CENTRAL_ARTICLES = 'SET_CENTRAL_ARTICLES'
export const SET_ALL_ARTICLES = 'SET_ALL_ARTICLES'
export const SET_IS_NEXT_BUTTON_DISABLED = 'SET_IS_NEXT_BUTTON_DISABLED'
export const SET_IS_PREVIOUS_BUTTON_DISABLED = 'SET_IS_PREVIOUS_BUTTON_DISABLED'
export const SET_REACHED_FIRST_PAGE = 'SET_REACHED_FIRST_PAGE'
export const SET_LOADING = "SET_LOADING"
export const SET_ERROR = "SET_ERROR"

/** Action creators */
export const setCategories = (categories) => ({
    type: SET_CATEGORIES,
    payload: categories
})

export const setCentralArticles = (centralArticles) => ({
    type: SET_CENTRAL_ARTICLES,
    payload: centralArticles
})

export const setAllArticles = (allArticles) => ({
    type: SET_ALL_ARTICLES,
    payload: allArticles
})

export const setIsNextButtonDisabled = (isNextButtonDisabled) => ({
    type: SET_IS_NEXT_BUTTON_DISABLED,
    payload: isNextButtonDisabled
})

export const setIsPreviousButtonDisabled = (isPreviousButtonDisabled) => ({
    type: SET_IS_PREVIOUS_BUTTON_DISABLED,
    payload: isPreviousButtonDisabled
})

export const setReachedFirstPage = (reachedFirstPage) => ({
    type: SET_REACHED_FIRST_PAGE,
    payload: reachedFirstPage
})

export const setLoading = (loading) => ({
    type: SET_LOADING,
    payload: loading
})

export const setError = (error) => ({
    type: SET_ERROR,
    payload: error
})